<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
          v-for="(item, index) in errors"
          :key="index"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <!-- <v-col cols="12">
        <v-autocomplete
          label="Supplier"
          v-model="supplierId"
          :items="suppliers"
          :search-input.sync="searchInput"
          item-value="id"
          no-filter
          :loading="fetchingSupplier || searchingSupplier"
        >
          <template v-slot:selection="{ item }">
            <span>{{ item.id }}</span>
            <span class="blue-grey--text mx-1 text-caption">{{ item.name }}</span>
          </template>
          <template v-slot:item="{ item }">
            <span class="blue--text">{{ item.id }}</span>
            <span class="mx-1"></span>
            <small>{{ item.name }}</small>
          </template>
        </v-autocomplete>
      </v-col> -->
      <v-col cols="12">
        <v-autocomplete
          label="Stock Code"
          :items="splrPrdList"
          item-value="stock_id"
          :loading="splrPrdLoading"
          v-model="stockId"
          no-filter
          clearable
          :search-input.sync="searchInput"
        >
          <template v-slot:selection="{ item }">
            <span>{{ item.stock_code }}</span>
            <span class="blue-grey--text mx-1 text-caption">{{ item.product_name }} ({{ item.brand_name }}})</span>
          </template>
          <template v-slot:item="{ item }">
            <span class="blue--text">{{ item.stock_code }}</span>
            <span class="mx-1"></span>
            <small>{{ item.product_name }} ({{ item.brand_name }})</small>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          v-model.number="retail"
          type="number"
          :disabled="!stockId"
          label="Price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          label="Quantity"
          type="number"
          v-model.number="quantity"
          :disabled="!stockId"
          :suffix="`/${unit}`"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="primary"
          dark
          :loading="verifying"
          @click="addToList"
        >Add</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  import { errorHandler } from '@/extra-functions/store.extra'
  import consumerLoanInventoryRepository from '@/repositories/consumer-loan-inventory.repository'
  import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
  import splrPrdRepository from '@/repositories/supplier-product.repository'
  import { apiVars } from '@/extra-functions/api-helper.extra'
  const supplierSearchDelay = searchDelay()
  const splrPrdDelay = searchDelay()
  export default {
    name: 'create-consumer-loan-inventory',
    props: {
      propConsumerId: String,
      propConsumerLoanId: String,
    },
    data () {
      return {
        ...apiVars('splrPrd'),
        searchingSupplier: false,
        stockId: null,
        retail: null,
        unit: 'none',
        quantity: null,
        verifying: false,
        errors: [],
        searchInput: null,
      }
    },
    created () {
      this.getSplrPrd()
      // this.fetchSuppliers({ index: 0, count: 10, search: '' })
    },
    computed: {
      ...mapState({
        storeId: state => state.settings.storeId,
        suppliers: state => state.supplier.list,
        fetchingSupplier: state => state.supplier.fetching,
        // supplierProducts: state => state.supplierProduct.list,
        supplierProductFetching: state => state.supplierProduct.fetching,
        supplierProductUpdate: state => state.supplierProduct.channelUpdate,
      }),
      // computedSupplierProducts () {
      //   return this.splrPrdList.map(this.computeSupplierProduct)
      // },
      cost () {
        return this.selectedStock.cost || 0
      },
      selectedStock () {
        return this.splrPrdList.find(e => e.stock_id === this.stockId)
      },
      supplierId () {
        const supplierPrd = this.splrPrdList.find(item => item.stock_id === this.stockId)
        return supplierPrd.supplier_id
      },
    },
    watch: {
      searchInput (val) {
        if (!val && val !== undefined) return
        this.getSplrPrd()
      },
      // supplierId (supplierId) {
      //   this.getSplrPrd()
      //   // this.fetchSupplierProducts(supplierId)
      // },
      selectedStock (obj) {
        if (!obj) return
        this.retail = obj.retail
        this.unit = obj.unit
      },
      supplierProductUpdate () {
        this.getSplrPrd()
        // this.fetchSupplierProducts(this.supplierId)
      },
    },
    methods: {
      ...mapActions({
        fetchSuppliers: 'supplier/fetch',
        fetchSupplierProducts: 'supplierProduct/fetch',
        addConsumerLoanInventory: 'consumerLoanInventory/addToTempList',
      }),
      getSplrPrd () {
        // if (!this.splrPrdLoading) {
        this.splrPrdLoading = true
        this.splrPrdErrors = []
        splrPrdDelay(() => {
          splrPrdRepository.paginate(this.storeId, { search: this.searchInput })
            .then(({ data }) => { this.splrPrdList = data })
            .catch(e => { this.splrPrdErrors = errorHandler(e) })
            .then(() => { this.splrPrdLoading = false })
        })
        // }
      },
      addToList () {
        if (!this.verifying) {
          this.verifying = true
          this.errors = []
          const data = {
            id: indexKeyGenerator(),
            consumer_loan_id: this.propConsumerLoanId,
            supplier_id: this.supplierId,
            stock_id: this.stockId,
            unit: this.unit,
            retail: this.retail,
            quantity: this.quantity,
            cost: this.cost,
          }
          const extraData = {
            stock_code: this.selectedStock.stock_code,
            product_name: this.selectedStock.product_name,
          }
          const params = {
            consumer: this.propConsumerId,
            consumerLoan: this.propConsumerLoanId,
          }
          consumerLoanInventoryRepository.verify(params, data)
            .then(this.verifySuccess(extraData).bind(this))
            .catch(e => { this.errors = errorHandler(e) })
            .then(() => { this.verifying = false })
        }
      },
      funcSearchSupplier () {
        this.searchingSupplier = true
        supplierSearchDelay(() => {
          this.searchingSupplier = false
          this.fetchSuppliers({ index: 0, count: 10, search: this.searchInput })
        })
      },
      verifySuccess (exData) {
        return function ({ data }) {
          this.addConsumerLoanInventory({
            ...data,
            ...exData,
          })
        }
      },
      // computeSupplierProduct (e) {
      //   const stock = e.stock
      //   const unit = stock.unit
      //   const sales = !e.sale_inventory.length ? 0 : e.sale_inventory[0].quantity
      //   const lost = !e.lost_inventory.length ? 0 : e.lost_inventory[0].quantity
      //   const recieved = !e.recieved_inventory.length ? 0 : e.recieved_inventory[0].quantity
      //   const loan = !e.consumer_loan_inventory.length ? 0 : e.consumer_loan_inventory[0].quantity
      //   return {
      //     ...e,
      //     unitDesc: unit.description,
      //     productName: stock.product_name,
      //     brandName: stock.brand_name,
      //     quantity: this.quantity,
      //     date_sold: this.dateTransaction,
      //     qRemaining: recieved - (sales + lost + loan),
      //   }
      // },
    },
  }
</script>
